import { UseQueryResult, useQuery } from 'react-query'
import { request } from '../request'
import { User } from '../../lib/types/User'

export const useGetUser = (): UseQueryResult<User, Error> => {
  return useQuery(
    ['currentUser'],
    () =>
      request<User>({
        url: '/auth/user',
        method: 'GET',
      }),
    {
      retry: 0,
      refetchInterval: 60 * 1000,
    },
  )
}
